import { DatePicker } from '@gravity-ui/date-components';
import { dateTimeParse } from '@gravity-ui/date-utils';
import { Col, Row, TextInput } from '@gravity-ui/uikit';
import { useMemo } from 'react';
import { FilterSettings } from '../../VideoList/types/FilterSettings';
import { getUnixTimestamp } from '../utils/getUnixTimestamp';
import { pageT } from '../../../i18n/page.i18n';

type VideoFilterProps = {
    filter: FilterSettings;
    onChange: (filter: FilterSettings) => void;
};

export function VideoFilter({ filter, onChange }: VideoFilterProps) {
    const { title, start_ts, end_ts } = filter;

    const { datesValid, startError, endError } = useMemo(() => {
        let startError = undefined,
            endError = undefined;
        if (start_ts !== null && start_ts < 0) {
            startError = pageT('invalidDate');
        }
        if (end_ts !== null && end_ts < 0) {
            endError = pageT('invalidDate');
        }
        if (
            start_ts !== null &&
            end_ts !== null &&
            start_ts > 0 &&
            end_ts > 0 &&
            start_ts > end_ts
        ) {
            startError = pageT('dateFromAfterDateTo');
        }
        return { datesValid: !startError && !endError, startError, endError };
    }, [start_ts, end_ts]);

    return (
        <Row space={2}>
            <Col s={6}>
                <TextInput
                    placeholder={pageT('searchByTitle')}
                    value={title}
                    onChange={(event) => onChange({ ...filter, title: event.target.value })}
                />
            </Col>
            <Col s={3}>
                <DatePicker
                    hasClear
                    label={pageT('dateFrom')}
                    format="DD/MM/YYYY HH:mm:ss"
                    placeholder={pageT('datePlaceholder')}
                    value={start_ts ? dateTimeParse(start_ts * 1000) : null}
                    onUpdate={(date) =>
                        onChange({ ...filter, start_ts: getUnixTimestamp(date?.toDate()) ?? null })
                    }
                    errorMessage={startError}
                    validationState={datesValid ? undefined : 'invalid'}
                    style={{ width: '100%' }}
                />
            </Col>
            <Col s={3}>
                <DatePicker
                    hasClear
                    label={pageT('dateTo')}
                    format="DD/MM/YYYY HH:mm:ss"
                    placeholder={pageT('datePlaceholder')}
                    value={end_ts ? dateTimeParse(end_ts * 1000) : null}
                    onUpdate={(date) =>
                        onChange({ ...filter, end_ts: getUnixTimestamp(date?.toDate()) ?? null })
                    }
                    errorMessage={endError}
                    validationState={datesValid ? undefined : 'invalid'}
                    style={{ width: '100%' }}
                />
            </Col>
        </Row>
    );
}
